import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { LabelText } from "../label-text/label-text.es.js";
import { FieldsetImpl, FieldsetLegend } from "./fieldset.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  hideLegend: PropTypes.bool,
  legend: PropTypes.string
};
const defaultProps = {
  hideLegend: false,
  legend: void 0
};
const Fieldset = forwardRef(
  ({ children, legend, hideLegend, ...restProps }, ref) => /* @__PURE__ */ jsxs(
    FieldsetImpl,
    {
      ...restProps,
      ref,
      "aria-label": hideLegend ? legend : void 0,
      space: "xsmall",
      children: [
        !hideLegend && /* @__PURE__ */ jsx(LabelText, { as: FieldsetLegend, children: legend }),
        children
      ]
    }
  )
);
Fieldset.propTypes = propTypes;
Fieldset.defaultProps = defaultProps;
export {
  Fieldset
};
